/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {


  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

// currency format start
function formatMoney(cents) {
  let amount = cents / 100;
  let formatted = new Intl.NumberFormat("lt-LT", {
    style: "currency",
    currency: "EUR"
  }).format(amount);
    return "€" + formatted.replace("€", "").trim();
}
// currency format end
  
//get product tags (sample) from cart object start
async function fetchCartWithTags(cartItems) {
  try {
    let sampleCount = 0; // Track occurrences of "sample"
    for (const item of cartItems) {
      const productResponse = await fetch(`/products/${item.handle}.json`);
        if (!productResponse.ok) {
          continue;
        }      
        const productData = await productResponse.json();
        let productTags = productData.product.tags || [];
        if (typeof productTags === "string") {
          productTags = productTags.toLowerCase().split(',').map(tag => tag.trim());
        } else if (Array.isArray(productTags)) {
          productTags = productTags.map(tag => tag.toLowerCase());
        }
        if (productTags.some(tag => tag.includes("sample"))) {
          sampleCount++; // Increment count if "sample" is found
        }
        if (sampleCount >= 2) {
          break; // Stop checking once we reach two occurrences
        }
      }
       
      const hasSampleProduct = sampleCount >= 2; // Only true if "sample" appears twice
      // disable/enable add to cart button on section 
      const buttons = document.querySelectorAll(".custom-sample-slider .org-add-to-cart");
      buttons.forEach(button => {
          button.disabled = hasSampleProduct;
          button.style.visibility = hasSampleProduct ? "hidden" : "visible";
      });
    } catch (error) {
       // console.error("❌ Error in fetchCartWithTags:", error);
    }
  }
  //get product tags (sample) from cart object end


  // get added sample product Id's start
   function getProductIdsFromButtons() {
          return Array.from(document.querySelectorAll(".custom-sample-slider .custom-added-button"))
            .map(button => ({
              id: parseInt(button.getAttribute("data-product-id"), 10),
              element: button
            }))
            .filter(item => !isNaN(item.id)); // Ensures valid numbers
        }
        
        function getProductsInCart(productIds, cartItems) {
          return productIds.filter(item => 
            cartItems.some(cartItem => cartItem.product_id === item.id)
          );
        }
  // get added sample product Id's end
  
  document.addEventListener("click", function (event) {
    if (event.target.id === "collection__filters_accordian") {
 // document.getElementById("collection__filters_accordian").addEventListener("click", function () {

      document.querySelector('.collection-filter-custom .drawer__close').click();
    // document.querySelectorAll(".sidebar__filter__group").forEach(item => {
    //     let button = item.querySelector("[data-accordion-trigger]");
    //     let content = item.querySelector("[data-accordion-body]");
    //     if (button && content) {
    //         button.setAttribute("aria-expanded", "true"); // Mark as expanded
    //         content.style.display = "block"; // Show content
    //         button.classList.add("accordion-is-open"); // Add class to button
    //     }
    // });
      
  }
});


document.addEventListener('theme:cart:change', function (event) {
  if (document.body.classList.contains("template-cart")) {
    var cart = event.detail.cart;
    const cartItems = cart.items; 
 

       // check discount rule applied - Free sample start
      // Find items with "Free sample" in the discounts array
     //  const freeSamples = cartItems
     //    .filter(item => item.discounts?.some(discount => discount.title === "Free sample"))
     //    .map(item => ({
     //      id: item.id,
     //      quantity: item.quantity
     //    }));

     //  const buttons = document.querySelectorAll(".custom-sample-slider button");
     //  const hasFreeSamples = freeSamples.length > 0;
      
     //  buttons.forEach(button => {
     //      button.disabled = hasFreeSamples;
     //      button.style.visibility = hasFreeSamples ? "hidden" : "visible";
     //  });
     // check discount rule applied - Free sample end

        // check sample item in cart already start 
        const productButtons = getProductIdsFromButtons(); // Get product IDs & elements
        const productsInCart = getProductsInCart(productButtons, cartItems); // Check in cart
       // check sample item in cart already start
       productsInCart.forEach(item => {
          item.element.classList.remove("hide-me"); // Remove 'hide-me' from main button

         let nextButton = item.element.nextElementSibling;
            while (nextButton) {
              if (nextButton.classList.contains("org-add-to-cart")) {
                nextButton.classList.add("hide-me"); // Add 'hide-me' to the next button
                break; // Stop after finding the correct sibling
              }
              nextButton = nextButton.nextElementSibling; // Move to the next element
            }
        });
         // check sample item in cart already end

         // execute product tags (sample) from cart function start 
          fetchCartWithTags(cartItems);
        // execute product tags (sample) from cart function start 

        // check discount rule applied start - Dovana

         const freeGift = cartItems
          .filter(item => item.discounts?.some(discount => discount.title === "Dovana"))
          .map(item => ({
            id: item.id,
            quantity: item.quantity
          }));

        
         const gifrsection = document.querySelector(".custom-collection-fifity");
      const buttons_gift = document.querySelectorAll(".custom-collection-fifty button");
      const hasFreeGift = freeGift.length > 0;
      
     // console.log(hasFreeGift ? "Free samples found:" : "No free samples found.", freeGift);
      console.log(hasFreeGift,'hasFreeGift');
      buttons_gift.forEach(buttons_gift => {
          buttons_gift.disabled = hasFreeGift;
          buttons_gift.style.visibility = hasFreeGift ? "hidden" : "visible";
       //  gifrsection.style.visibility = hasFreeGift ? "hidden" : "visible";
        gifrsection.classList.toggle("hide-me", hasFreeGift == true);
      });
       // check discount rule applied end - Dovana

      
      // show/hide cart section 
    // var cart = event.detail.cart;
      var cartsubtotal = parseFloat(formatMoney(cart.items_subtotal_price)
          .replace(/€/g, "")
          .replace(/\./g, "")
          .replace(",", "."));
      
      const cartTotalfix = 50;
      //console.log(cart);
        var cartItemcount = cart.item_count;
//        alert(cartItemcount);

      document.querySelector('#cart50').classList.toggle("hide-me", cartsubtotal < cartTotalfix);
    //  document.querySelector('#free-sample-cart').classList.toggle("hide-me", 0 <= cartItemcount);
        document.querySelector('#free-sample-cart').classList.toggle("hide-me", cartItemcount === 0);

        

      //  document.querySelector('#free-sample-cart').classList.toggle("hide-me", cartsubtotal <= cartTotalfix);
        
     // show/hide cart section end

      
        // print cart left amount
      const cartLimit = 39;
      if (cartLimit > cartsubtotal) {
        let leftAmount = (cartLimit - cartsubtotal).toFixed(2);
        //console.log(cartLimit, cartsubtotal, leftAmount);
        let leftAmount1 = parseInt(leftAmount.replace(".", "")); // Convert directly to integer
        let leftAmount2 = formatMoney(leftAmount1);
          document.querySelector('.left-cart-amount').textContent = leftAmount2;
         document.querySelector('.left-cart-title').textContent = 'Iki nemokamo pristatymo liko';
      } else {
          document.querySelector('.left-cart-amount').textContent = '';
        document.querySelector('.left-cart-title').textContent = 'Jums taip pat gali patikti';
      }
      // print cart left amount end
      }
    });
  
  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
document.getElementById("mobile-search").addEventListener("click", () => {
  document.getElementById("custom-search").click();
});
